import { useTranslation } from 'react-i18next';
import { createShortUrl } from '../../services';
import './loginMessage.scss';
type LoginMessageProp = {
  message: string;
  currentUrlToRedirect: string;
  inputError: string;
};
const LoginMessage: React.FC<LoginMessageProp> = (props) => {
  // ! for language
  const { t } = useTranslation();
  const { message, currentUrlToRedirect, inputError } = props;
  const tempUrlBeforeLogin = window.location.pathname;
  const LoginbtnHandler = async () => {
    if (tempUrlBeforeLogin.includes('/cross-reference/short/') || inputError) {
      window.location.href = `/MyDigiKey?returnUrl=https://${document.location.host}${document.location.pathname}`;
    } else if (currentUrlToRedirect) {
      const resultUrl = await createShortUrl(currentUrlToRedirect);
      const pathname = window.location.pathname.split('/');
      const languageParam = pathname[1];
      if (languageParam) {
        if (languageParam.length === 2) {
          window.location.href = `/MyDigiKey?returnUrl=http://${window.location.host}/${languageParam}/cross-reference/${resultUrl.id}`;
        } else {
          window.location.href = `/MyDigiKey?returnUrl=http://${window.location.host}/cross-reference/${resultUrl.id}`;
        }
      }
    } else {
      window.location.href = `/MyDigiKey?returnUrl=https://${window.location.host}${window.location.pathname}`;
    }
  };
  return (
    <p>
        {message}
        <button
            onClick={LoginbtnHandler}
            data-testid="login-btn"
            className="dk-btn__primary"
            id="login-btn"
        >
            {t('xref-login-btn')}
        </button>
    </p>
  );
};
export default LoginMessage;
